var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-progress-bar"},[_c('div',{staticClass:"base-progress-bar__bar",class:_vm.testfull,style:({width: _vm.currentPercent})})])}
var staticRenderFns = []

export { render, staticRenderFns }